<template>
    <div class="flex-grow-1 overflow-y-auto p-0 w-100 h-100">
        <!-- TÍTULO DA PÁGINA COM TOGGLE DE VISIBILIDADE -->
        <div v-if="form?.show_title !== false" class="py-4 px-4 bg-white border-bottom"
            :class="form?.title_align || 'text-center'">
            <h1 class="fw-bolder m-0" :style="{ color: form?.title_color || '#5F0487', fontSize: '1.8rem' }">
                {{ form?.title || 'Título da Página' }}
            </h1>
        </div>

        <div v-if="!form?.sections || form.sections.length === 0" class="text-center text-muted py-5">
            <i class="bi bi-puzzle fs-1 d-block mb-2"></i>
            <span class="small">Sua página está vazia.</span>
        </div>

        <div v-for="(section, idx) in form?.sections || []" :key="'prev_' + idx"
            :class="section.type !== 'dailypag_crowdfunding' ? 'py-5 px-4' : ''"
            :style="section.type !== 'dailypag_crowdfunding' ? { backgroundColor: section.content?.bg_color || '#ffffff' } : {}">

            <!-- PREVIEW: RMR CROWDFUNDING -->
            <div v-if="section.type === 'dailypag_crowdfunding'" class="rmr-crowdfunding-container p-3 p-md-4"
                style="background-color: #f8fafc;">
                <div class="row g-4">
                    <div class="col-lg-12 col-xl-7">
                        <!-- CAPA DA CAMPANHA -->
                        <div v-if="section.content.show_cover_image !== false" class="position-relative mb-3">
                            <img :src="section.content.cover_image || 'https://via.placeholder.com/800x450?text=Sua+Capa+Aqui'"
                                class="img-fluid rounded-4 w-100 object-fit-cover shadow-sm"
                                style="height: 300px; border: 1px solid #e2e8f0;">

                            <!-- CATEGORIA -->
                            <div v-if="section.content.show_category !== false && section.content.category"
                                class="position-absolute top-0 end-0 m-3 bg-white text-dark fw-bold rounded-pill px-3 py-1 shadow-sm fs-7">
                                <i class="bi bi-tag-fill me-1" style="color: #5F0487;"></i> {{ section.content.category
                                }}
                            </div>
                        </div>

                        <!-- TÍTULO DA CAMPANHA -->
                        <h2 v-if="section.content.show_title !== false" class="fw-bolder text-dark mb-2"
                            style="font-size: 1.7rem; letter-spacing: -0.5px;">{{ section.content.title }}</h2>

                        <!-- LOCALIZAÇÃO -->
                        <p v-if="section.content.show_location !== false && section.content.location"
                            class="text-muted lh-base mb-3" style="font-size: 0.95rem;">
                            <i class="bi bi-geo-alt-fill me-1" style="color: #5F0487;"></i> {{ section.content.location
                            }}
                        </p>

                        <!-- RESUMO BREVE -->
                        <div v-if="section.content.show_short_description !== false && section.content.short_description"
                            class="text-secondary lh-base mb-4 bg-white p-3 rounded-3 border border-light shadow-sm rich-preview"
                            style="font-size: 0.95rem;" v-html="section.content.short_description"></div>

                        <ul class="nav nav-tabs rmr-tabs border-bottom-0 mb-3">
                            <li class="nav-item">
                                <button @click="switchTab('history')"
                                    class="nav-link fw-bold border-0 border-bottom border-3 px-2 me-3 bg-transparent"
                                    :class="{ active: activeTab === 'history' }"
                                    :style="activeTab === 'history' ? 'color: #5F0487; border-color: #5F0487 !important;' : 'color: #6c757d;'">
                                    Nossa História
                                </button>
                            </li>
                            <li class="nav-item">
                                <button @click="switchTab('supporters')"
                                    class="nav-link fw-medium border-0 border-bottom border-3 px-2 me-3 bg-transparent"
                                    :class="{ active: activeTab === 'supporters' }"
                                    :style="activeTab === 'supporters' ? 'color: #5F0487; border-color: #5F0487 !important;' : 'color: #6c757d;'">
                                    Mural de Apoio ({{ currentSupporters?.length || 0 }})
                                </button>
                            </li>
                        </ul>

                        <div class="bg-white p-4 rounded-4 shadow-sm border border-light">

                            <!-- ================= 1. ABA: NOSSA HISTÓRIA ================= -->
                            <div v-if="activeTab === 'history'">
                                <!-- HISTÓRIA COMPLETA (ABA SOBRE) -->
                                <div v-if="section.content.show_about_text !== false"
                                    class="rich-preview text-secondary lh-lg" style="font-size: 0.9rem;"
                                    v-html="section.content.about_text"></div>

                                <!-- CHAVE PIX RÁPIDA E DIRETA -->
                                <div v-if="section.content.pix_copy_paste && section.content.show_pix_key !== false"
                                    class="p-4 rounded-4 mb-0 mt-4 shadow-sm bg-white border position-relative overflow-hidden">

                                    <!-- TOAST FLUTUANTE DE SUCESSO -->
                                    <transition name="fade">
                                        <div v-if="pixCopied"
                                            class="position-absolute top-0 start-0 w-100 h-100 bg-success text-white d-flex align-items-center justify-content-center gap-2 fw-bold shadow-sm"
                                            style="z-index: 10;">
                                            <i class="bi bi-check-circle-fill fs-5"></i>
                                            <span>Chave copiada com sucesso!</span>
                                        </div>
                                    </transition>

                                    <div class="d-flex align-items-center gap-2 mb-3">
                                        <div class="rounded-circle p-2 d-flex align-items-center justify-content-center"
                                            style="background-color: rgba(95, 4, 135, 0.1); color: #5F0487; width: 36px; height: 36px;">
                                            <i class="bi bi-lightning-charge-fill fs-5"></i>
                                        </div>
                                        <div>
                                            <span class="d-block fw-bold text-dark" style="font-size: 0.95rem;">Doação
                                                Rápida via PIX</span>
                                            <span class="text-muted small">Escaneie o QR Code ou copie o código
                                                abaixo</span>
                                        </div>
                                    </div>

                                    <!-- QR CODE EXIBIDO DIRETAMENTE -->
                                    <div v-if="section.content.pix_qrcode_image"
                                        class="text-center mb-3 p-3 bg-light rounded-3">
                                        <img :src="'data:image/jpeg;base64,' + section.content.pix_qrcode_image"
                                            alt="QR Code Pix" class="img-fluid rounded shadow-sm"
                                            style="max-width: 170px;">
                                        <span class="d-block text-muted small mt-2">Aponte a câmera do celular para
                                            pagar</span>
                                    </div>

                                    <!-- BOTÃO / INPUT DE COPIAR CÓDIGO PIX -->
                                    <div class="input-group input-group-md shadow-sm">
                                        <input type="text"
                                            class="form-control bg-light text-muted font-monospace border-end-0"
                                            :value="section.content.pix_copy_paste" readonly
                                            style="font-size: 0.75rem;">
                                        <button class="btn fw-bold px-4 text-white" style="background-color: #5F0487;"
                                            @click="copyPixCode(section.content.pix_copy_paste)">
                                            <i class="bi bi-clipboard me-1"></i> Copiar Código
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- CONTEÚDO DA ABA: MURAL DE APOIO -->
                            <div v-else-if="activeTab === 'supporters'">

                                <div v-if="!section.supporters || section.supporters.length === 0"
                                    class="text-center py-4 text-muted">
                                    <i class="bi bi-heart fs-3 d-block mb-2 text-secondary opacity-50"></i>
                                    <span class="small">Ainda não há apoiadores confirmados. Seja o primeiro a
                                        ajudar!</span>
                                </div>

                                <div v-else class="d-flex flex-column gap-3 supporters-scroll-container pe-1">
                                    <div v-for="(sup, idx) in section.supporters" :key="idx"
                                        class="p-3 bg-light rounded-3 border-0">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <span class="fw-bold text-dark small">
                                                <i class="bi bi-person-circle me-1" style="color: #5F0487;"></i> {{
                                                    sup.name }}
                                            </span>
                                            <span class="badge bg-success-subtle text-success fw-bold">R$ {{
                                                formatCurrency(sup.amount) }}</span>
                                        </div>

                                        <p v-if="sup.comment" class="text-secondary small mb-1 fst-italic">
                                            "{{ sup.comment }}"
                                        </p>

                                        <span class="text-muted" style="font-size: 0.7rem;">
                                            <i class="bi bi-clock me-1"></i>{{ sup.time_ago }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-xl-5">
                        <div class="position-sticky" style="top: 20px;">
                            <div class="bg-white p-4 rounded-4 shadow-sm border border-light mb-3 text-center">
                                <!-- VALOR ARRECADADO -->
                                <div v-if="section.content.show_raised_amount !== false">
                                    <p class="text-muted fw-bold mb-1 text-uppercase" style="font-size: 0.75rem;">Total
                                        Arrecadado</p>
                                    <h2 class="fw-bolder mb-2"
                                        style="font-size: 2.2rem; letter-spacing: -1px; color: #5F0487;">
                                        <!-- 👇 Alterado de section.content.raised_amount para section.total_raised -->
                                        R$ {{ formatCurrency(section.total_raised) }}
                                    </h2>
                                </div>

                                <!-- META TOTAL -->
                                <p v-if="section.content?.show_goal !== false" class="text-muted mb-4"
                                    style="font-size: 0.85rem;">
                                    Objetivo: R$ {{ formatCurrency(section.goal_amount || section.content?.goal_amount
                                        || 0) }}
                                </p>

                                <div class="progress mb-4 bg-light shadow-inner"
                                    style="height: 10px; border-radius: 20px;">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar"
                                        :style="{ width: section.progress_percentage + '%', backgroundColor: '#5F0487' }">
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center gap-4 mb-4">
                                    <!-- APOIADORES -->
                                    <div class="d-flex justify-content-center gap-4 mb-4">
                                        <!-- APOIADORES -->
                                        <div v-if="section.content.show_supporters !== false" class="text-center">
                                            <div class="fw-bold text-dark fs-5">{{ section.total_supporters }}</div>
                                            <div class="small text-muted">Apoiadores</div>
                                        </div>

                                        <div v-if="section.content.show_supporters !== false && section.content.show_goal !== false"
                                            class="vr opacity-25"></div>

                                        <!-- ALCANÇADO % -->
                                        <div v-if="section.content.show_goal !== false" class="text-center">
                                            <div class="fw-bold text-dark fs-5">{{ section.progress_percentage }}%</div>
                                            <div class="small text-muted">Alcançado</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- BOTÃO DE DOAÇÃO DINÂMICO (Nome e Cor personalizados) -->
                                <button @click="$emit('openCheckout', section.content)"
                                    class="btn w-100 py-3 fw-bold rounded-pill mb-2 shadow-sm text-white"
                                    :style="{ backgroundColor: section.content.button_color || '#5F0487' }">
                                    {{ section.content.button_text || 'Quero Ajudar Agora' }}
                                </button>

                                <!-- BOTÃO DE COMPARTILHAR (Controlado pelo ícone de olho) -->
                                <button v-if="section.content.show_share_button !== false"
                                    @click="isShareModalOpen = true"
                                    class="btn btn-light w-100 py-2 fw-medium rounded-pill border text-dark">
                                    <i class="bi bi-share me-1"></i> Compartilhar
                                </button>

                                <ShareModal v-if="isShareModalOpen" :title="campaignTitle"
                                    @close="isShareModalOpen = false" />
                            </div>

                            <!-- ORGANIZADOR -->
                            <div v-if="section.content.show_creator !== false && section.content.creator_name"
                                class="bg-white p-3 rounded-4 shadow-sm border border-light d-flex align-items-center gap-3">
                                <div class="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold fs-5 shadow-sm"
                                    style="width: 45px; height: 45px; background-color: #5F0487;">
                                    {{ getInitials(section.content.creator_name) }}
                                </div>
                                <div class="text-start">
                                    <div class="small text-muted mb-0 lh-1">Organizado por:</div>
                                    <h6 class="fw-bold text-dark mb-0 mt-1" style="font-size: 0.95rem;">{{
                                        section.content.creator_name }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PREVIEW: TEXTO RICO -->
            <div v-else-if="section.type === 'text'">
                <h2 v-if="section.content?.show_title !== false && section.content?.title" class="fw-bolder mb-3"
                    :style="{ color: section.content?.accent_color || '#5F0487' }">{{ section.content.title }}</h2>
                <div v-if="section.content?.show_text !== false" class="m-0 rich-preview w-100"
                    :style="{ color: section.content?.accent_color || '#374151' }" v-html="section.content?.text"></div>
            </div>

            <!-- PREVIEW: YOUTUBE -->
            <div v-else-if="section.type === 'youtube'" class="text-center">
                <h3 v-if="section.content?.show_title !== false && section.content?.title" class="fw-bolder mb-3"
                    :style="{ color: section.content?.accent_color || '#5F0487' }">
                    {{ section.content.title }}
                </h3>

                <div v-if="section.content?.show_url !== false" class="mx-auto" style="max-width: 640px;">
                    <!-- Se houver uma URL válida do YouTube, exibe o Iframe do vídeo -->
                    <div v-if="getYouTubeEmbedUrl(section.content?.url)"
                        class="ratio ratio-16x9 rounded-4 overflow-hidden shadow-lg border">
                        <iframe :src="getYouTubeEmbedUrl(section.content.url)" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen>
                        </iframe>
                    </div>

                    <!-- Placeholder caso o campo de URL esteja vazio -->
                    <div v-else
                        class="bg-dark rounded-4 d-flex align-items-center justify-content-center mx-auto shadow"
                        style="height: 220px; max-width: 380px; border: 4px solid #fff;">
                        <div class="text-white opacity-75">
                            <i class="bi bi-play-circle-fill fs-1 d-block mb-1"></i>
                            <span class="small">Insira uma URL do YouTube no editor</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PREVIEW: CONTATO -->
            <div v-else-if="section.type === 'contact'" class="text-center">
                <h3 v-if="section.content?.show_title !== false" class="fw-bolder mb-3"
                    :style="{ color: section.content?.accent_color || '#5F0487' }">
                    {{ section.content?.title || 'Fale Conosco' }}
                </h3>
                <div class="d-flex justify-content-center gap-3 flex-wrap">
                    <span v-if="section.content?.show_whatsapp !== false && section.content?.whatsapp"
                        class="badge rounded-pill bg-success px-4 py-2 fs-6 shadow-sm"><i
                            class="bi bi-whatsapp me-2"></i>{{ section.content.whatsapp }}</span>
                    <span v-if="section.content?.show_email !== false && section.content?.email"
                        class="badge rounded-pill bg-dark px-4 py-2 fs-6 shadow-sm"><i
                            class="bi bi-envelope me-2"></i>{{ section.content.email }}</span>
                </div>
            </div>

            <!-- PREVIEW: BOTÃO DE AÇÃO / PAGAMENTO GENÉRICO -->
            <div v-else-if="section.type === 'payment'" class="text-center">
                <template v-if="section.content?.show_button_text !== false">

                    <!-- SE A AÇÃO FOR REDIRECIONAR PARA UM LINK -->
                    <a v-if="section.content.button_action === 'link'" :href="section.content?.button_link || '#'"
                        target="_blank"
                        class="btn btn-lg fw-bold rounded-pill shadow-lg px-5 py-3 text-decoration-none d-inline-flex align-items-center justify-content-center transition-all hover-lift"
                        :style="{ backgroundColor: section.content?.accent_color || '#5F0487', color: 'white' }">
                        <i class="bi bi-box-arrow-up-right me-2"></i> {{ section.content?.button_text || 'Acessar' }}
                    </a>

                    <!-- SE A AÇÃO FOR ABRIR O CHECKOUT (Padrão) -->
                    <button v-else @click="$emit('openCheckout', section.content)"
                        class="btn btn-lg fw-bold rounded-pill shadow-lg px-5 py-3 d-inline-flex align-items-center justify-content-center transition-all hover-lift"
                        :style="{ backgroundColor: section.content?.accent_color || '#5F0487', color: 'white' }">
                        <i class="bi bi-cart me-2"></i> {{ section.content?.button_text || 'Comprar' }}
                    </button>

                </template>
            </div>

            <!-- PREVIEW: CARROSSEL -->
            <div v-else-if="section.type === 'carousel'">
                <h3 v-if="section.content?.show_title !== false && section.content?.title"
                    class="fw-bolder mb-4 text-center" :style="{ color: section.content?.accent_color || '#5F0487' }">
                    {{ section.content?.title }}
                </h3>

                <!-- Galeria Normal (Quadradinhos Fixos) -->
                <div class="d-flex gap-3 overflow-x-auto pb-3 justify-content-center px-2">
                    <div v-for="(img, i) in (section.content?.images || [])" :key="i"
                        class="flex-shrink-0 rounded-4 overflow-hidden shadow-sm gallery-thumbnail"
                        @click="openImageModal(img.url)" style="width: 150px; height: 150px; border: 3px solid #fff;">

                        <img v-if="img.url" :src="img.url" style="width: 100%; height: 100%; object-fit: cover;" />

                        <div v-else
                            class="d-flex align-items-center justify-content-center h-100 bg-light text-muted small">
                            <i class="bi bi-image fs-3"></i>
                        </div>
                    </div>
                </div>

                <!-- Modal Lightbox flutuante (Aparece apenas quando uma imagem é clicada) -->
                <div v-if="selectedImageUrl" class="lightbox-overlay" @click="closeImageModal">
                    <div class="lightbox-content" @click.stop>
                        <!-- Botão de fechar (X) -->
                        <button class="btn-close-lightbox" @click="closeImageModal">
                            <i class="bi bi-x-lg"></i>
                        </button>

                        <!-- Imagem em tamanho real -->
                        <img :src="selectedImageUrl" class="lightbox-image" alt="Imagem Ampliada">
                    </div>
                </div>
            </div>

            <!-- OUTROS -->
            <div v-else class="text-center">
                <h3 class="fw-bold mb-2">{{ section.content?.title || 'Título' }}</h3>
                <p class="text-muted">{{ section.content?.subtitle || 'Subtítulo...' }}</p>
            </div>

        </div>
    </div>
</template>

<script>
import ShareModal from '../ShareModal.vue';

export default {
    name: 'PagePreviewRenderer',
    components: {
        ShareModal
    },
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            activeTab: 'history',
            isShareModalOpen: false,
            pixCopied: false,
            selectedImageUrl: null
        };
    },
    computed: {
        currentSupporters() {
            const crowdfundingSection = (this.form?.sections || []).find(s => s.type === 'dailypag_crowdfunding');
            // Garante fallback para array vazio se for undefined
            return crowdfundingSection?.supporters || this.form?.supporters || [];
        },
        campaignTitle() {
            const crowdfundingSection = (this.form?.sections || []).find(s => s.type === 'dailypag_crowdfunding');
            return crowdfundingSection?.content?.title || this.form?.title || 'Campanha de Arrecadação';
        }
    },
    methods: {
        formatCurrency(v) {
            return parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getInitials(name) {
            if (!name || typeof name !== 'string') return 'R';
            const parts = name.trim().split(' ');
            if (parts.length >= 2 && parts[0] && parts[1]) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return name.substring(0, 2).toUpperCase();
        },
        toggleQrCode(idx) {
            this.showQrCodeIndex = this.showQrCodeIndex === idx ? null : idx;
        },
        async copyPixCode(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.pixCopied = true;
                setTimeout(() => {
                    this.pixCopied = false;
                }, 3500); // O alerta some sozinho após 3.5 segundos
            } catch (err) {
                alert('Não foi possível copiar o código.');
            }
        },
        getYouTubeEmbedUrl(url) {
            if (!url || typeof url !== 'string') return null;

            // Adicionado 'shorts\/' na lista de padrões aceitos pela Regex
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);

            return (match && match[2] && match[2].length === 11)
                ? `https://www.youtube.com/embed/${match[2]}`
                : null;
        },
        async switchTab(tab) {
            this.activeTab = tab;
        },
        openImageModal(url) {
            if (!url) return;
            this.selectedImageUrl = url;
            document.body.style.overflow = 'hidden';
        },

        closeImageModal() {
            this.selectedImageUrl = null;
            document.body.style.overflow = 'auto';
        }
    }
}
</script>

<style scoped>
.btn-rmr-primary {
    background-color: #5F0487;
    color: white;
    transition: all 0.2s ease-in-out;
}

.btn-rmr-primary:hover {
    background-color: #4a036a;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(95, 4, 135, 0.3) !important;
}

.shadow-inner {
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
}

.rmr-tabs .nav-link {
    color: #6c757d;
    padding-bottom: 10px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.hover-lift {
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.hover-lift:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
}

.supporters-scroll-container {
    max-height: 410px;
    overflow-y: auto;
}

.supporters-scroll-container::-webkit-scrollbar {
    width: 5px;
}

.supporters-scroll-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 8px;
}

.supporters-scroll-container::-webkit-scrollbar-thumb {
    background: #5F0487;
    border-radius: 8px;
}

.supporters-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #4a036a;
}
.gallery-thumbnail {
    cursor: zoom-in;
    transition: transform 0.2s ease;
}

.gallery-thumbnail:hover {
    transform: scale(1.03);
}

.lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999; 
    padding: 1rem;
    animation: fadeIn 0.25s ease-out;
}

.lightbox-content {
    position: relative;
    max-width: 100%;
    max-height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.lightbox-image {
    max-width: 100%;
    max-height: 85vh;
    object-fit: contain;
    border-radius: 12px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
}

.btn-close-lightbox {
    position: absolute;
    top: -40px;
    right: 0;
    background: transparent;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 5px;
    transition: transform 0.2s;
}

.btn-close-lightbox:hover {
    transform: scale(1.2);
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>